module.exports = __webpack_public_path__ + "img/tbs.51e490bf.svg";